module.exports = __webpack_public_path__ + "res/img_demo_user.eac2a38f8849e05db19863781363abd9.webp";